<template>
  <div class="wrapper">
    <div class="container">
      <h3 class="title">Start your 7 days<br class="hide-in-desktop"> FREE trial</h3>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";

.wrapper {
  display: block;
  min-height: 100vh;
  background: transparent linear-gradient(180deg, #FDFBFA 0%, #FBF5F3 72%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
  padding: 80px 0 108px;

  @include mobile {
    background: transparent linear-gradient(180deg, #FCFAF9 0%, #FFFFFF 49%, #FAF4F2 100%) 0% 0% no-repeat padding-box;
  }
  .title {
    margin-bottom: 44px;

    @include mobile {
      margin-bottom: 32px;
    }
  }
}
</style>